<template>
  <div>

    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/normalFlow/videoCallDetails.png" alt="contact-img" width="85%"/>
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png" alt="contact-img" width="70%"/>
        </div>
      </div>
    </transition>
    <div class="card px-3 py-5   " style="width: 80%; margin: 0 auto ">
      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <div class="columns is-centered">
          <div class="column is-full ps-5" style="text-align: center">
            <img src="../assets/images/icons/Blue/Frame 37763.png" alt="contact-info-img" width="70" height="70"/>
            <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`"
               style="font-family: OpenSans-Bold; ">
              {{ $root.selectedLanguageData.videocalldetails }}
            </p>
            <p :class="`${$root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
              }`"
               style="font-family: OpenSans-Bold; ">
              {{ $root.selectedLanguageData.selectthedateandtimeforthevideocall }}
            </p>
            <p style="font-family: OpenSans-Regular; ">
              {{ $root.selectedLanguageData.fill_the_below_form }}
            </p>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="">
          <div class="columns is-centered">
            <div class="column is-three-quarters pt-5 ps-5">

              <div class="mt-4 columns">
                <div class="column is-half">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{
                      $root.selectedLanguageData.preferreddate
                    }}<span class="has-text-danger">*</span>
                  </label>
                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <b-datepicker

                        position="is-top-right"


                        v-model="$root.formData.videoCallDate"
                        :unselectable-days-of-week="[0,6]"
                        :unselectable-dates="unselectableDates"
                        :min-date="minDate"
                        @input="()=>{

                        if($root.selecteableTimeSlotsArray != []){
                          $root.selecteableTimeSlotsArray = []

                        }

                        if($root.formData.videoCallTimeSlot !== ''){
                          $root.formData.videoCallTimeSlot = ''
                        }

                        if(checkIsItToday()){
                          isToday = true
                            getBankAvailableTime()
                            getTimeSlotList()

                        }
                        else {
                              isToday = false
                              getTimeSlotList()

                        }
                        
                     
                          
                     
                   
                        
                      
                       
                      }"
                        icon-right="calendar">
                    </b-datepicker>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>

                </div>
                <div class="column is-half">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{
                      $root.selectedLanguageData.preferredtime
                    }}<span class="has-text-danger">*</span>
                  </label>
                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <b-select
                        @focus="$inputFocused('videoCallTimeSlot')"
                        @input="$inputChanged('videoCallTimeSlot')"
                        @blur="$inputBlured('videoCallTimeSlot')"
                        v-model="$root.formData.videoCallTimeSlot" expanded>
                      <option v-for="(timeSlot, index) in $root.selecteableTimeSlotsArray" :value="timeSlot.time"
                              :key="index" :disabled="timeSlot.isDisabled === true">
                        {{ timeSlot.time }}
                      </option>
                    </b-select>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>


            </div>

          </div>
          <p style="width: 75%; margin: 0 auto; padding-bottom: 8px;"><span>{{ $root.selectedLanguageData.note }}</span>
            {{ $root.selectedLanguageData.videocallshedulenote }}</p>
          <p style="width: 75%; margin: 0 auto" v-if="isToday">{{ $root.selectedLanguageData.isTodayTrue }}</p>
          <p style="width: 75%; margin: 0 auto" v-if="!isToday">{{ $root.selectedLanguageData.isTodayFalse }}</p>

          <div class="is-centered columns my-3">
            <div
                class="column is-5 is-offset-4 is-flex is-flex-direction-row-reverse"
            >
              <b-button
                  :disabled="invalid"
                  :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                  @click="submitPageInputs(isContinueButtonLoading, 'preview-page', 'documents_id', 'preview-page', 1)"
              >

                <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                {{ $root.selectedLanguageData.continue }}
              </b-button>
              <b-button
                  @click="$router.push('documents_id')"
                  :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

              >{{ $root.selectedLanguageData.back }}
              </b-button>
            </div>
          </div>

        </form>
      </ValidationObserver>


    </div>

  </div>
</template>

<script>
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";


export default {


  components: {
    Logo,

  },
  data() {

    return {
      selectedDate: null,
      holidayArray: "",
      timeSlotsArray: [],
      bankHolyDays: [],
      unselectableDates: [],
      closedTime: "",
      timeObj: new Date(),
      timeGap: null,
      currentTime: "",
      endTime: "",
      minDate: "",
      isToday: true,
      submitPageInputs: submitPageInputs,
      isContinueButtonLoading: false

    };
  },
  methods: {

    // videoCallScheduler(){
    //
    //
    //
    // },


    // formatDate(date){
    //   let year = date.getFullYear();
    //   let month = date.getMonth() + 1;
    //   let day = date.getDate()

    //   if(month < 10){
    //     month = "0"+month;
    //   }
    //   let output = [month,day,year]
    //   return output.join("/")
    // },
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token + '.' + this.$root.formData.color_code4 + '.' + this.$root.formData.color_code12
        this.$http
            .post(this.$baseURL + "/kycForm/updateLastStep", {
              last_step_name: 'Document Upload',
              last_step: 7,
              form_filled: true,
              next_route: 'Employment Info',
            }, {
              headers: {'X-token': kyc_token}
            })
            .then((response) => {
              console.log(response.data);

              if (response.data.success) {
                console.log(response.data);
              } else {
                console.log(response.data);
              }
            }).catch((response) => {
          this.$buefy.toast.open({
            message: response.message,
            type: "is-danger",
          });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    checkIsItToday() {

      // Get the current date
      const currentDate = new Date();
      // Get the selected date
      const selectedDate = this.$root.formData.videoCallDate;

      // Compare date, month, and year
      const isSameDateAndMonthAndYear =
          currentDate.getDate() === selectedDate.getDate() &&
          currentDate.getMonth() === selectedDate.getMonth() &&
          currentDate.getFullYear() === selectedDate.getFullYear();

      console.log("Is current date, month, and year the same as selected date, month, and year?", isSameDateAndMonthAndYear);
      return isSameDateAndMonthAndYear;
    },


    // timeSchedulerConcatonator(){


    //   for (let i=0; i<=this.timeSlotsArray.length-2; i++){
    //     console.log("this.timeSlotsArray[i].disable", this.timeSlotsArray[i].disable)
    //     let timeObj={
    //                     time :  this.timeSlotsArray[i].time + " to " + this.timeSlotsArray[i+1].time,
    //                     isDisabled : this.timeSlotsArray[i].disable,
    //                     };
    //     this.selecteableTimeSlotsArray.push(timeObj)
    //   }
    // },

    timeCapture() {
      this.$root.formData.currentTime = this.timeObj.getHours() + ":" + this.timeObj.getMinutes();
    },

    // timeScheduleCalculator(){
    //   this.currentTime = (this.timeObj.getHours()*60)+this.timeObj.getMinutes()
    //   let timeGap = this.endTime - this.currentTime
    //      console.log("this.endTime", this.endTime)
    //   console.log("this.currentTime", this.currentTime)
    //   console.log("time Gap", timeGap)
    //   console.log("this.timeObj.getDate()", this.timeObj.getDate())
    //   if (timeGap>=120){
    //     this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate())
    //     console.log( "Min Date " +this.minDate)
    //     console.log("Day "+ this.timeObj.getDate())
    //     this.isToday = true;
    //   }
    //   else {
    //     this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate()+1)
    //     console.log( "Min Date " +this.minDate)
    //     console.log("Day "+ this.timeObj.getDate())
    //     this.isToday = false;
    //   }

    //   console.log("this.isToday", this.isToday)


    // },

    getBankAvailableTime() {
      console.log("Function kicked")
      try {
        const comp = this;
        comp.$http
            .post(comp.$baseURL + "/bankOpeningClosingTime", {}, {})
            .then((response) => {
              //console.log("getBankAvailableTime",response.data)
              comp.closedTime = response.data.bankEndTime
              let [hours, minutes] = comp.closedTime.split(':').map(Number);
              comp.endTime = hours * 60 + minutes
              comp.currentTime = (comp.timeObj.getHours() * 60) + comp.timeObj.getMinutes()

              let timeGap = comp.endTime - comp.currentTime
              // console.log("timeGap", timeGap)
              //console.log("this.endTime", comp.endTime)
              //console.log("this.currentTime", comp.currentTime)
              if (timeGap >= 240) {
                comp.minDate = new Date(comp.timeObj.getFullYear(), comp.timeObj.getMonth(), comp.timeObj.getDate())
                // console.log( "Min Date " +comp.minDate)
                //  console.log("Day "+ comp.timeObj.getDate())
                comp.isToday = true;
                // console.log("this.isToday = true>>>>")
              } else {
                comp.minDate = new Date(comp.timeObj.getFullYear(), comp.timeObj.getMonth(), comp.timeObj.getDate() + 1)
                // console.log( "Min Date " +comp.minDate)
                // console.log("Day "+ comp.timeObj.getDate())
                comp.isToday = false;
                // console.log("this.isToday = false>>>>")
              }
              console.log("this.isToday", comp.isToday)
            })

      } catch (err) {
        console.log(err)
      }
    },


    getHolidayList() {
      try {
        // console.log("----------start-----------");

        let kyc_token = this.$root.formData.kyc_token + '.' + this.$root.formData.color_code4 + '.' + this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/getHolidays", {}, {
              headers: {'X-token': kyc_token}
            })
            .then((response) => {
              // console.log("bank Holidays")
              //console.log(response.data);
              this.bankHolyDays = response.data;
              this.bankHolyDaysFormatter();

              // console.log("---------------------");
            })

        // this.disabledDates();
      } catch (err) {
        console.log(err)
      }
    },

    helloOne() {
      console.log("Grater>>>>>>")
    },
    helloTwo() {
      console.log("Equal>>>>>>")
    },

    getTimeSlotList() {
      try {

        // console.log("----------start-----------");

        let kyc_token = this.$root.formData.kyc_token + '.' + this.$root.formData.color_code4 + '.' + this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/getTimeSlots", {"is_today": this.isToday}, {
              headers: {'X-token': kyc_token}
            })
            .then((response) => {
              let comp = this
              //console.log(response.data.data);
              comp.timeSlotsArray = response.data.data;
              comp.closedTime = response.data.systemEnd
              let [hours, minutes] = comp.closedTime.split(':').map(Number);
              comp.endTime = hours * 60 + minutes
              //console.log("---------------------");
              // this.timeSchedulerConcatonator()
              // this.timeScheduleCalculator()

              for (let i = 0; i <= comp.timeSlotsArray.length - 2; i++) {
                //console.log("this.timeSlotsArray[i].disable", comp.timeSlotsArray[i].disable)
                let timeObj = {
                  time: comp.timeSlotsArray[i].time + " to " + comp.timeSlotsArray[i + 1].time,
                  isDisabled: comp.timeSlotsArray[i].disable,
                };
                //console.log("timeObj", timeObj)
                comp.$root.selecteableTimeSlotsArray.push(timeObj)
              }
            })

      } catch (err) {
        console.log(err)
      }
    },


    bankHolyDaysFormatter() {
      this.bankHolyDays.forEach((holyDay) => {
        let dateParts = holyDay.date.split("-");
        let year = parseInt(dateParts[0]);
        let month = parseInt(dateParts[1]) - 1;
        let date = parseInt(dateParts[2]);
        this.unselectableDates.push(new Date(year, month, date))
      })
      return this.unselectableDates

    }

  },
  mounted() {
    // this.updateLastStep();

    // this.getHolidayList();

    // this.bankHolyDaysFormatter();
    // this.timeCapture();
    // this.timeScheduleCalculator()


    setTimeout(() => {
      this.getBankAvailableTime();
      this.getHolidayList();
    }, 100);


    // this.getTimeSlotList();

  },
}

</script>